import { amplitudeLib } from 'freedom-shared';

export const aviaTourPromoOfferShown = () => {
  amplitudeLib.logEvent('trfree_offer_shown', { source: 'avia' });
};

export const aviaTourPromoOfferClicked = () => {
  amplitudeLib.logEvent('trfree_offer_clicked', { source: 'avia' });
};
